import { api } from "../utils/api";

const getAcl = async () => {
  try {
    const response = await api.get("WaybeeUsers/getAcl");
    return response.data;
  } catch (e) {
    console.error(e);
  }

  return [];
};

const getClassAcl = async classId => {
  try {
    const response = await api.get(`ClassDiaryV1/class/${classId}/acl`);
    return response.data;
  } catch (e) {
    console.error(e);
  }

  return [];
};

const AclService = {
  getClassAcl,
  getAcl
};

export default AclService;
